import { NgModule } from '@angular/core';
import { FooterV2Component } from './footer-v2.component';
import { FooterV2RoutingModule } from './footer-v2-routing.module';
import { SharedModule } from '../@shared/shared.module';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
    declarations: [FooterV2Component],
    imports: [
        CommonModule,
        SharedModule,
        FooterV2RoutingModule,
        MatExpansionModule,
        // UtilitiesModule,
    ],
    exports: [FooterV2Component],
})
export class FooterV2Module {
    constructor() {}
}
